<template>
  <div class="rounded-full px-6 bg-smoke flex-shrink-0 text-sm h-10 flex items-center mb-2">
    <span class="text-payneHot capitalize">{{ humanize(filterName) }}</span>
    <span class="inline-block mx-4 capitalize">“{{ humanize(filterVal) }}”</span>
    <button type="button" @click.prevent="removeFilter" :dusk="`clear-${filterName}-filter-badge`" class="transition duration-150 ease-in-out rounded-md p-1 border border-transparent focus:outline-none focus:border-yankFire">
      <XIcon class="h-2 text-yankFire"/>
    </button>
  </div>
</template>
<script>
import XIcon from "@/components/svg/XIcon"

export default {
  name: 'FilterBadge',

  props: {
    filterVal: String,
    filterName: String,
  },

  components: {XIcon},

  computed: {
    query() {
      return this.$page.props.query
    },
  },

  methods: {
    removeFilter() {
      this.$emit('remove')
    },

    humanize(string) {
      return string.replaceAll('-', ' ').replaceAll('_', ' ').replaceAll(' and ', ' & ')
    }
  }
}
</script>
